import React from 'react';
import { Connected, IConnectedList } from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { goBack, push } from 'connected-react-router';
import { connect } from 'react-redux';
import { useLocalErrorHandler } from 'hooks';

const ConnectedEcContainer = ({
    getEcs, ecsList, apiError, setErrorHandler,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [processing, setProcessing] = React.useState(false);

    React.useEffect(() => {
        const fetchQec = async () => {
            setProcessing(true);
            await getEcs({});
            setProcessing(false);
        };

        fetchQec();
    }, []);

    return (
        <Connected
          getList={getEcs}
          apiError={apiError}
          ecsList={ecsList as IConnectedList}
          cardCategory="Список ЭЦ, с которыми вы сотрудничаете"
          showLoader={processing}
          withBorder
          onlyWatch
        />
    );
};

const mapState = (state: IRootState) => ({
    ecsList: state.expert.qecsList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    onGoBack: () => dispatch(goBack()),
    getEcs: dispatch.expert.getQecsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(ConnectedEcContainer);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;
